<template>
  <div>
    <section-title content="Información de Contacto" :has-line="true" />
    <div class="contact-information-list mt-3">
      <custom-callout
        v-for="(contact, idx) in value"
        :key="idx"
        class="mb-2"
        :show-edition="
          !disabled &&
            editMode &&
            editInfo.data != null &&
            editInfo.index == idx
        "
      >
        <div class="row">
          <div class="col-sm-1 text-center align-middle mt-2">
            <div class="dot text-center color-white">
              <i class="fa fa-phone fa-flip-horizontal" />
            </div>
          </div>
          <div class="col-sm cell">
            <div class="data">
              <span>
                Contacto {{ contact.isPrimary ? 'Primario' : 'Secundario' }}:
              </span>
              <p>
                {{ contact.nameFirst }} {{ contact.nameLastPaternal }}
                {{ contact.nameLastMaternal }}
              </p>
            </div>
          </div>
          <div class="col-sm cell">
            <span>Posición:</span>
            <p>{{ contact.workPositionTitle }}</p>
          </div>
          <div class="col-sm cell">
            <span>Trabajo:</span>
            <p>{{ contact.telephoneWorkNo | phone }}</p>
          </div>
          <div class="col-sm cell">
            <span>Celular:</span>
            <p>{{ contact.telephoneMobileNo | phone }}</p>
          </div>
          <div
            v-if="!disabled && canPerformActions"
            class="col-sm cell actions"
          >
            <drop-down :data-item="idx" :items="getAvailableActions(contact)" />
          </div>
        </div>

        <template v-if="editMode && editInfo.index == idx" #edition>
          <contact-information-add-edit
            v-model="editInfo.data"
            :civil-statuses="civilStatuses"
            :disable-primary="value.length < 2 && editInfo.data?.isPrimary"
            @on-cancel="onContactCanceled"
            @on-saved="onContactSaved"
          />
        </template>
      </custom-callout>
      <custom-callout
        class="mb-2"
        :show-container="false"
        :show-edition="!disabled && createMode"
      >
        <template #edition>
          <contact-information-add-edit
            v-model="editInfo.data"
            :civil-statuses="civilStatuses"
            :disable-primary="value.length == 0"
            @on-cancel="onContactCanceled"
            @on-saved="onContactSaved"
          />
        </template>
      </custom-callout>
      <div v-if="!disabled" class="row mt-3">
        <div class="col">
          <action-button
            v-if="editInfo.data == null && canAddContact"
            class="float-right"
            i="fas fa-plus"
            text="Añadir"
            variant="success"
            @click="newContact"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle';
import CustomCallout from '@/components/common/CustomCallout';
import ContactInformationAddEdit from './ContactInformationAddEdit';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'ContactInformationList',
  components: {
    CustomCallout,
    ContactInformationAddEdit,
    SectionTitle,
  },
  mixins: [alert],
  props: {
    value: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onSaving: {
      type: Function,
      default: () => {},
    },
    onDeleting: {
      type: Function,
      default: () => {},
    },
    addEnabled: {
      type: Boolean,
      default: true,
    },
    editEnabled: {
      type: Boolean,
      default: true,
    },
    deleteEnabled: {
      type: Boolean,
      default: true,
    },
    civilStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editInfo: {
        index: 0,
        data: null,
      },
      editMode: false,
      createMode: false,
    };
  },
  computed: {
    actions() {
      return [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          click: this.onEdit,
          visible: this.isEditVisible,
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          click: this.onDelete,
          visible: this.isDeleteVisible,
        },
      ];
    },
    canAddContact() {
      return this.addEnabled;
    },
    canPerformActions() {
      return this.editEnabled || this.deleteEnabled;
    },
  },
  watch: {
    value: function(newValue) {
      if (newValue.length == 0 && !this.disabled) {
        this.newContact();
      }
    },
  },
  async mounted() {},
  methods: {
    getAvailableActions(item) {
      let actions = [
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          click: this.onEdit,
          visible: !this.disabled && this.editEnabled,
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          click: this.onDelete,
          visible: !this.disabled && this.deleteEnabled && !item.isPrimary,
        },
      ];

      return actions;
    },
    newContact() {
      this.createMode = true;
      this.editMode = false;

      this.editInfo = this.getNewContactModel();
    },
    onEdit(dataItemIndex) {
      this.editMode = true;
      this.createMode = false;

      this.editInfo = {
        index: dataItemIndex,
        data: this.value[dataItemIndex],
      };
    },
    async onDelete(dataItemIndex) {
      await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el contacto seleccionado?',
        'Sí',
        'No'
      ).then(async (answer) => {
        if (answer) {
          let isValid = true;

          if (this.onDeleting != undefined)
            isValid = await this.onDeleting(this.value[dataItemIndex].id);

          if (isValid) {
            this.value.splice(dataItemIndex, 1);
          }
        }
      });
    },
    async onContactSaved(savedContact) {
      this.clearEditCreate();
      let isValid = true;

      if (this.onSaving != undefined)
        isValid = await this.onSaving(savedContact);

      if (isValid) return;

      if (savedContact.isNew) {
        savedContact.isNew = false;
        this.value.push(savedContact);
      } else {
        var foundIndex = this.value.findIndex((x) => x.id == savedContact.id);
        this.value[foundIndex] = savedContact;
      }

      if (savedContact.isPrimary)
        for (let i = 0; i < this.value.length; i++)
          if (this.value[i] != savedContact) this.value[i].isPrimary = false;

      if (savedContact.signMonthlyCertifications)
        for (let i = 0; i < this.value.length; i++)
          if (this.value[i] != savedContact)
            this.value[i].signMonthlyCertifications = false;
    },
    async onContactCanceled() {
      this.clearEditCreate();
    },
    clearEditCreate() {
      this.createMode = false;
      this.editMode = false;

      this.editInfo = {
        index: 0,
        data: null,
      };
    },
    getNewContactModel() {
      const newContactModel = {
        data: {
          id: null,
          nameFirst: null,
          workDepartmentName: null,
          telephoneMobileNo: null,
          nameLastPaternal: null,
          workPositionTitle: null,
          welephoneWorkNo: null,
          nameLastMaternal: null,
          email: null,
          telephoneHomeFaxNo: null,
          isPrimary: this.value.length == 0,
          signMonthlyCertifications: false,
          isNew: true,
        },
      };

      return newContactModel;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../shared/scss/config/fonts.scss';
@import '../../../../shared/scss/config/colors.scss';

.contact-information-list .cell {
  display: table-cell !important;
  vertical-align: middle;
  margin-left: 2.2rem;
}

.contact-information-list .cell span {
  color: map-get($colors, 'gray-6');
  font-size: map-get($fontsSize, 'font-14');
}

.contact-information-list .cell p {
  color: map-get($colors, 'black');
  font-size: map-get($fontsSize, 'font-16');
  margin-bottom: 0;
}

.contact-information-list .cell.actions {
  text-align: right;
  margin-top: 5px;
}
.dot {
  background-color: #ff7058;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.is-big-icon {
  margin-left: 3px;
}
.color-white {
  color: white;
}
</style>
